/* eslint-disable class-methods-use-this */

export default class BSClass {
    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'bs-landing-page-button':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'FI kort tilmeld BS',
                    'eventAction': 'Landing Page',
                    'eventLabel': 'Klik Tilmeld BS',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            
            case 'bs-landing-page-cross':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'FI kort tilmeld BS',
                    'eventAction': 'Landing Page',
                    'eventLabel': 'Luk pÃ¥ kryds',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            
            case 'bs-receit-page-cross':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'FI kort tilmeld BS',
                    'eventAction': 'Kvitteringsside',
                    'eventLabel': 'Luk pÃ¥ kryds',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            
            case 'bs-receit-page-bills':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'FI kort tilmeld BS',
                    'eventAction': 'Kvitteringsside',
                    'eventLabel': 'Klik se ubetalte regninger',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
        }
        
        return trackingObject;
    }
}
